const INITIAL_STATE = {
  uuid: '',
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case 'STORE_APPLICATION_UUID':
      return {
        ...state,
        uuid: payload,
      };
    default:
  }
  return state;
};
